import React from "react";
import NtkHeader from "../common/NtkHeader";
import ServiceBox from "../common/ServiceBox";
import NtkParagraph from "../common/NtkParagraph";
import NtkButton from "../common/NtkButton";
import { Grid, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  grid: {
    justifyContent: "center",
    marginBottom: "2em",
  },
  btnGrid: {
    marginTop: "2.8em",
    marginBottom: "-2em",
    justifyContent: "center",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "1em",
      paddingRight: "1em",
    },
  },
}));
const HowItWorksWithSteps = ({ header, paragraph, cardData, withButton }) => {
  const classes = useStyles();
  return (
    <>
      <NtkHeader header={header} />
      <NtkParagraph paragraph={paragraph} />
      <Grid container className={classes.grid}>
        {cardData &&
          cardData.map(({ id, header, paragraph }) => (
            <ServiceBox key={id} header={header} paragraph={paragraph} />
          ))}

        {withButton ? (
          <>
            <Grid container className={classes.btnGrid}>
              <NtkButton title="Get Started" />
              <NtkParagraph paragraph="Rates depend on project size, content/domain, and turnaround time." />
            </Grid>
          </>
        ) : null}
      </Grid>
    </>
  );
};

export default HowItWorksWithSteps;
